import HomeScreen from './screens/home';
import Departamento from './screens/departamento';
import PedidoDetalhe from './screens/pedidoDetalhe';
import HistoricoPedido from './screens/historicoPedido';
import Configuracoes from './screens/configuracoes';

const routes = {
    Home: {
        screen: HomeScreen,
        path: '/'
    },
    PedidoDetalhe: {
        screen: PedidoDetalhe,
        path: '/pedido-detalhe'
    },
    Departamento: {
        screen: Departamento,
        path: '/departamento'
    },
    HistoricoPedido: {
        screen: HistoricoPedido,
        path: '/pedido-historico'
    },
    Configuracoes: {
        screen: Configuracoes,
        path: '/configuracoes'
    }
};

export const initialRouteName = {
    initialRouteName: 'HomeScreen'
};

export default routes;
